'use client'
import dynamic from 'next/dynamic'

import type { AcfForm } from '@typings'
import { useSettings } from '@contexts/settings.context'

const FormContextProvider = dynamic(() =>
  import('@contexts/form.context').then(({ FormContextProvider }) => ({
    default: FormContextProvider,
  }))
)

const RaForm = dynamic(() =>
  import('@components/form-elements/RaForm/RaForm').then(({ RaForm }) => ({
    default: RaForm,
  }))
)

export const RaFormWrapper = (props: AcfForm) => {
  const { destination, GTM_ID, ROLLBAR_ENV, ROLLBAR_TOKEN } = useSettings()

  return (
    <FormContextProvider
      destination={destination}
      GTM_ID={GTM_ID}
      ROLLBAR_ENV={ROLLBAR_ENV}
      ROLLBAR_TOKEN={ROLLBAR_TOKEN}>
      <RaForm {...props} />
    </FormContextProvider>
  )
}

RaFormWrapper.displayName = 'RaFormWrapper'
